import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import { periodFilterStyle, yearsFilterStyle } from "../../../services/utils";
import ReactSelect, { components } from "react-select";
import { setEventStatsYear } from "../../../actions/actions/eventStats";


const DropdownIndicator = props => {
  return (
    <components.DropdownIndicator {...props}>
      <img src={"/img/icons/Polygon.svg"} className={'mr-1'} />
    </components.DropdownIndicator>
  );
};

const PeriodFilter = ({yearsOptions, setEventStatsYear}) => {

  const handleSelectChange = (value) => {
    let selectedYears = value.map(year => '' + year.value);
    setEventStatsYear(selectedYears);
  }

  const currentYear = moment().year();
  const computedYears = yearsOptions ? yearsOptions : [
    { value: (currentYear + 1), label: (currentYear + 1) },
    { value: (currentYear), label: (currentYear) },
    { value: (currentYear - 1), label: (currentYear - 1) },
    { value: (currentYear - 2), label: (currentYear - 2) },
    { value: (currentYear - 3), label: (currentYear - 3) }
    ];

    const defaultYearOption = computedYears.find(
      (opt) => opt.value === currentYear
    );

    return (
      /*<ReactSelect
        className="my-2 mx-4 event-small-filter"
        onChange={this.handleSelectChange}
        styles={periodFilterStyle()}
        defaultValue={{value: (moment().format('YYYY')), label: (moment().format('YYYY'))}}
        options={yearsOptions}
        components={{ DropdownIndicator, IndicatorSeparator:() => null, Input:() => null}}
      />*/
      <ReactSelect
        onChange={handleSelectChange}
        isClearable={false}
        isMulti
        styles={yearsFilterStyle()}
        defaultValue={defaultYearOption ? [defaultYearOption] : []}
        options={computedYears}
        components={{ DropdownIndicator, IndicatorSeparator: () => null, Input: () => null, Placeholder: () => null }}
      />
    );
}

const mapStateToProps = state => ({});

const mapDispatchToProps = {
  setEventStatsYear,
};

export default connect(mapStateToProps, mapDispatchToProps)(PeriodFilter);



// WEBPACK FOOTER //
// ./app/components/Filters/EventStats/PeriodFilter.js